module.exports = __webpack_public_path__ + "static/img/Compart-blue.190fda7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Compart-blue.png
// module id = emta
// module chunks = 1